export default __webpack_public_path__ + "static/media/new-old-count.6c1cc1a6.png";